import { render, staticRenderFns } from "./sidebar-field-control.vue?vue&type=template&id=228f28fe&scoped=true"
import script from "./sidebar-field-control.vue?vue&type=script&lang=js"
export * from "./sidebar-field-control.vue?vue&type=script&lang=js"
import style0 from "./sidebar-field-control.vue?vue&type=style&index=0&id=228f28fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f28fe",
  null
  
)

export default component.exports